// IIFE - Immediately Invoked Function Expression
(function($, window, document) {

    // The $ is now locally scoped 

    // Listen for the jQuery ready event on the document
    $(function() {

        // The DOM is ready!

    });


// Submit com reCAPTCHA v3 + fetch (adaptado p/ terser)
document.getElementById('contact-form').addEventListener('submit', function(e) {
  e.preventDefault();
  var form = e.currentTarget;
  var btn  = document.getElementById('send-btn');
  btn.disabled = true;

  // grecaptcha v3
  grecaptcha.execute('6LdCjKErAAAAAOy0eGEuKvFoS2bCfwCKVfTYwdnv', { action: 'contact' }).then(function(token) {
    document.getElementById('recaptcha_token').value = token;

    var data = new FormData(form);
    return fetch(form.action, { method: 'POST', body: data });
  }).then(function(res) {
    var ct = res.headers.get('content-type');
    var isJSON = ct && ct.indexOf('application/json') !== -1;

    if (isJSON) {
      return res.json().then(function(payload){
        return { ok: true, payload: payload, res: res };
      });
    }
    return res.text().then(function(html){
      return { ok: true, payload: { ok: res.ok, html: html }, res: res };
    });
  }).then(function(pack) {
    var payload = pack.payload;

    if ((payload && payload.ok) || (payload && payload.ok === true)) {
      alert('Mensagem enviada com sucesso!');
      document.getElementById('contact-form').reset();
    } else {
      var msg = (payload && payload.error) ? payload.error :
                (payload && payload.errors ? payload.errors.join('\n') : 'Falha no envio.');
      alert(msg);
    }
  }).catch(function() {
    alert('Erro ao enviar. Tente novamente.');
  }).finally(function() {
    btn.disabled = false;
  });
});

// Inicializa reCAPTCHA v3
grecaptcha.ready(function(){ /* pronto para execute no submit */ });
    //AOS.init();

/*Accordion toggle*/
$(function() {
  $(".-accordion-filter--toggle").on('click', function(e) {
    //console.log($(this).find('i')[0].classList.value)
    /*var iconClass = $(this).find('i')[0].classList.value;
    if (iconClass === "fas fa-plus") {
      $(this).find('iconify')[0].classList.value = "fas fa-minus";
    }else{
      $(this).find('iconify')[0].classList.value = "fas fa-plus";
    }*/
    
      //$(this).find('i').text((e, text) => text === "+" ? "-" : "+");
     /*$(this).text((e, text) => text === "+" ? "-" : "+");*/

      $(`#${ $(this).data("toggle-content") }`).stop().slideToggle();
      
  });
});
/*document.addEventListener('click', function playOnce() {
  const videoFg = document.getElementById('bg-video');
  alert('clk')
  if (videoFg && videoFg.paused) { alert('paused')
    videoFg.play().catch(() => {});
  }
  // Remove this event after first click
  document.removeEventListener('click', playOnce);
});*/
/*document.addEventListener('DOMContentLoaded', function () {
  const videoFg = document.getElementById('bg-video');
  if (videoFg) {
    // Try to play after page load
    videoFg.play().catch(function(error) {
      console.log("Autoplay prevented, waiting for user interaction");
    });
  }
});    */



   
    //Menu trigger
    var menuTrigger = document.getElementsByClassName("menu-trigger-btn"),
        menu = document.getElementById("main-nav");
    
    var toggleMenu = function() {
    	   //console.log('main nav offcanvas called')
        //menu.classList.toggle("offcanvas-nav-active");
        document.body.classList.toggle("menu-active");
    };

    for (var i = 0; i < menuTrigger.length; i++) {
        menuTrigger[i].addEventListener('click', toggleMenu, false);
    }

    

    $('.nav-tab-btn').click(function(){
        event.preventDefault();
        var tabTarget = $(this).data('tab');
        /*console.log(tabTarget);*/
        $(this).closest('.tabs-wrap').find('.tabs-content').removeClass('-visible');
        $(this).closest('.tabs-wrap').find('.tabs-content#'+tabTarget).addClass('-visible');
        $(this).closest('.tabs-wrap').find('.nav-tab-btn').removeClass('-active');
        $(this).addClass('-active');
    });     
    
    

    function redirect(goto){
        /*var conf = confirm("Are you sure you want to go elswhere?");
        if (conf && goto != '') {
            window.location = goto;
        }*/
        window.location = goto;
    }
   
    /*Anchor scroll*/
    const anchors = document.querySelectorAll(".scroll-anchor");
     
    for (const anchor of anchors) {
      anchor.addEventListener("click", clickHandler);
    }
     
    function clickHandler(e) {
      e.preventDefault();
      const header = document.querySelector("header").offsetHeight;
      const href = this.getAttribute("href"); 
      const offsetTop = document.querySelector(href).offsetTop;
      document.body.classList.remove("menu-active");
     
      scroll({
        //top: offsetTop-header,
        top: offsetTop,
        behavior: "smooth"
      });
    }

    /*Anchor scroll nav*/
    const anchorsNav = document.querySelectorAll(".scroller > a");
     
    for (const anchorNav of anchorsNav) {
      anchorNav.addEventListener("click", clickHandlerNav);
    }
     
    function clickHandlerNav(e) {
      e.preventDefault();
      let header = document.querySelector("header").offsetHeight;
      let href = this.getAttribute("href"); 
      let split = href.split('#');
      let anchor = '#'+split[1];
      let offsetTop = document.querySelector(anchor).offsetTop;

      
      document.body.classList.remove("menu-active");
      
     
      scroll({
        /*top: offsetTop-header,*/
        top: offsetTop,
        behavior: "smooth"
      });
    } 


    /*Accordion*/
    $('[data-accordion]').click(function(e) {
        e.preventDefault();
        var parent = $(this).closest('.-accordion');
        /*var elParent = $(this).closest('.-accordion-item');*/

        //parent.find('.-accordion-item').removeClass('-active');

        if ( $(this).closest('.-accordion-item').hasClass('-active') ) {
            parent.find('.-accordion-item').removeClass('-active');
            $(this).closest('.-accordion-item').removeClass('-active');
        }else{
            parent.find('.-accordion-item').removeClass('-active');
            $(this).closest('.-accordion-item').addClass('-active');
        }
        
    });         
      

    /*Dropdown mobile*/
    $('.dropdown-toggle-hover').click(function(){
      
      if ($(window).width() < 1025) {
        event.preventDefault();
        var ddl = $(this).closest('.dropdown');
        ddl.toggleClass('open');
      }else{
        return;
      }
    });

    /*Tiny slider plans*/
    const tnsSliderTestimonials = document.querySelectorAll('.-testimonials-tns');
    tnsSliderTestimonials.forEach(sliderTestimonials => {
      const tnsSliderTestimonials = tns({
          container: sliderTestimonials,
          items: 3,
          nav: false,
          controls: true,
          autoplayButtonOutput: false,
          autoplay: false,
          autoplayTimeout: 4000,
          gutter: 36,
          loop: false,
          mouseDrag: true,
          controlsPosition: "bottom",
          controlsText: ['<span class="-prev"><iconify-icon icon="fluent:arrow-left-12-filled"></iconify-icon></span>', '<span class="-next"><iconify-icon icon="fluent:arrow-right-12-filled"></iconify-icon></span>'],
          responsive: { 
              1366: {
                items: 3,
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              768: {
                items: 3,
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              320: {
                /*loop: false,
                swipeAngle: false,
                items: 1.4,
                gutter: 24,*/
                items: 1,
                autoplay: true,
                loop: true,
                /*loop: true,
                autoplay: true,*/
                /*gutter: 0,*/
              }, 
          }           
      });
    }); 


    /*Tiny slider primary*/
    const tnsSliderHighlight = document.querySelectorAll('.-hg-tns');
    tnsSliderHighlight.forEach(sliderHG => {
      const tnsSliderHighlight = tns({
          container: sliderHG,
          
          items: 1,
          nav: false,
          controls: true,
          autoplayButtonOutput: false,
          autoplay: false,
          autoplayTimeout: 4000,
          gutter: 0,
          loop: true,
          mouseDrag: false,
          controlsText: ['<span class="-prev"><iconify-icon icon="lucide:arrow-left"></iconify-icon></span>', '<span class="-next"><iconify-icon icon="lucide:arrow-right"></iconify-icon></span>'],
          controlsContainer: "#customize-controls",
          controlsPosition: "bottom",
      });
    });     
  

                
     /*GDPR*/
    document.addEventListener('DOMContentLoaded', function() {
      var cookiebar = document.querySelector('.cookiebar');
      if (cookiebar) { 
          var closecookiebar = document.querySelector('.hide-cookiebar-target');
          var acceptcookie = document.querySelector('.accept-cookies');
          var refusecookie = document.querySelector('.refuse-cookies');
          var cookie = readCookie('wh_cookie_lgpd_consent');/*Name of cookie*/
          //console.log(cookie);

          if (cookie == "true") {
              cookiebar.style.display = "none";
          }else if (cookie == "false") {
              cookiebar.style.display = "none";
          }else{
              cookiebar.classList.add("no-cookie-yet");
          }

          acceptcookie.addEventListener('click', function(e) {
              if(cookie != "true") {
                cookiebar.style.display = "none";
                createCookie('wh_cookie_lgpd_consent', "true", 7);
              } 
              e.preventDefault();
          });

          if (refusecookie) {
            refusecookie.addEventListener('click', function(e) {
                if(cookie != "true") {
                  cookiebar.style.display = "none";
                  createCookie('wh_cookie_lgpd_consent', "false", 7);
                }
                e.preventDefault();
            });  
          }
          
          if (closecookiebar) {
            closecookiebar.addEventListener('click', function(e) {
                cookiebar.style.display = "none";
                /*if(cookie != "true") {
                  createCookie('wh_cookie_lgpd_consent', "true", 1);
                } */
                e.preventDefault();
            });
          }

      }

      function createCookie(name, value, days) {
          if(days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            var expires = "; expires=" + date.toGMTString();
          } else var expires = "";
          document.cookie = name + "=" + value + expires + "; path=/"
      }

      function readCookie(name) {
          var nameEQ = name + "=";
          var ca = document.cookie.split(';');
          for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
           
          }
          return null;
      }

      function eraseCookie(name) {
          createCookie(name, "", -1);
      }

    });             

    var header = document.querySelectorAll(".dynamic-header");
    if (!header.length) { return; }
    var headerHeight = header[0].offsetHeight;
    window.onscroll = function() {
      //console.log(window.innerWidth)
        var scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
        var vh1o3 = (window.innerWidth/3);
        var vh1o2 = (window.innerWidth/2);
        var vhMin = 100;
        var vhMinWA = 200;
        /*if (scrollPosition > headerHeight && window.innerWidth > 992) {*/
        /*if (scrollPosition > headerHeight) {*/
        if (scrollPosition > vhMin) {
                header[0].classList.add('-sticky');
                
        }else{
                header[0].classList.remove('-sticky');
                
        }

        if (scrollPosition > vhMinWA) {
                
                document.body.classList.add("-has-sticky");
        }else{
                
                document.body.classList.remove("-has-sticky");
        }
    }; 

   

}(window.jQuery, window, document));